// 261010 P9D D1 #3 — luật mode/tab trang truyện (THUẦN: 0 antd/router).
// Narration bị giấu (không còn toggle): mode MẶC ĐỊNH là film. Chỉ `?mode=narration` tường minh mới vào narration
// (cửa thoát ẩn). Tab chỉ-narration (characters/glossary/processes/episodes) không kèm mode=narration → film + tab mặc định film.

export const FILM_TABS = ['overview', 'adaptation', 'chapters', 'film'] as const;
export const NARRATION_TABS = ['overview', 'chapters', 'characters', 'glossary', 'processes', 'episodes'] as const;

export type StoryMode = 'film' | 'narration';
export type FilmTab = (typeof FILM_TABS)[number];
export type NarrationTab = (typeof NARRATION_TABS)[number];

export function modeOf(params: { mode?: string | null; tab?: string | null }): StoryMode {
  return params.mode === 'narration' ? 'narration' : 'film';
}

export function tabOf(params: { mode?: string | null; tab?: string | null }): string {
  const mode = modeOf(params);
  const items = mode === 'film' ? FILM_TABS : NARRATION_TABS;
  const tab = params.tab || '';
  if (tab && (items as readonly string[]).includes(tab)) return tab;
  return mode === 'film' ? 'film' : 'overview';
}

export function storyTabOf(params: { mode?: string | null; tab?: string | null }): { mode: StoryMode; tab: string } {
  return { mode: modeOf(params), tab: tabOf(params) };
}

/** Đổi Narration ↔ Film: giữ `tab` nếu tab còn trong items đích; không thì bỏ tab (về mặc định mode). */
export function nextSearchOnSetMode(
  current: { mode?: string | null; tab?: string | null },
  nextMode: StoryMode,
): { mode: StoryMode; tab?: string } {
  const items = nextMode === 'film' ? FILM_TABS : NARRATION_TABS;
  const tab = current.tab || '';
  if (tab && (items as readonly string[]).includes(tab)) return { mode: nextMode, tab };
  return { mode: nextMode };
}
